import styled from 'styled-components';

const FooterWrapperStyled = styled.div`
  width: 100%;
  position: relative;
`;

const FooterContentWrapStyled = styled.section`
  position: relative;
  display: flex;
  z-index: 97;
  background-color: #2d1540;
  justify-content: center;
  align-items: center;
`;

const FooterContainerStyled = styled.div`
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  margin-bottom: 50px;
  svg {
    margin-bottom: 20px;
  }
`;

export { FooterWrapperStyled, FooterContentWrapStyled, FooterContainerStyled };
